import {
  Box,
  Button,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  useMediaQuery,
} from "@mui/material";
import close_icon from "assets/icons/close.png";
import Loading from "components/Loading";
import PhoneField from "components/PhoneField";
import { useState } from "react";
import { AutoSizer, List } from "react-virtualized";
import { useStyles } from "./styles";

const initialState = {
  director_firstname: "",
  director_lastname: "",
  contract_id: "",
  postal_code: "",
  telephone: "",
};

export default function CustomerSelect({
  label,
  icon,
  onCustomerChange,
  clearCustomer,
  setCurrency,
  customerId,
  setCustomerId,
  customers,
  getCustomers,
  disableFind,
}) {
  const classes = useStyles();
  const [openSearch, setOpenSearch] = useState(false);
  const [form, setForm] = useState(initialState);
  const [isLoading, setIsLoading] = useState(false);
  const handleChange = (event) => {
    setForm((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = () => {
    setIsLoading(true);
    const newParams =
      form.director_firstname === "" &&
      form.director_lastname === "" &&
      form.contract_id === "" &&
      form.postal_code === "" &&
      form.telephone === ""
        ? undefined
        : form;
    getCustomers(newParams).finally(() => setIsLoading(false));
  };

  const rowRenderer = ({ index, key, style }) => {
    const option = customers[index];
    const value = option.customer_id;
    const isChecked = customerId === value;

    return (
      <div key={key} style={style}>
        <FormControlLabel
          value={value}
          className={classes.customerLabel}
          control={
            <Radio
              checked={isChecked}
              onChange={() => {
                setCustomerId(value);
                onCustomerChange &&
                  onCustomerChange({
                    firstname: option.director_firstname || "",
                    lastname: option.director_lastname || "",
                    country_id: option.country_id,
                    city: option.city || "",
                    postal_code: option.postal_code || "",
                    address: option.customer_address || "",
                    telephone: option.telephone || "",
                    email: option.email || "",
                    states_id: option.states_id || "",
                    contract_id: option.contract_id || "",
                    company_name: option.company_name || "",
                    taxpayer_id: option.taxpayer_id || 0,
                    other_states_name: option.other_states_name || "",
                    country_code: option.country_code || "",
                    passport_dateOfIssue: option.passport_dateOfIssue || null,
                    passport_number: option.passport_number || "",
                    sender: option,
                    selectedCountries:
                      option.country_code === "FR" ||
                      option.country_code === "DE",
                  });
                if (setCurrency) {
                  setCurrency(
                    option.country_name === "Poland" ||
                      option.country_id === "179"
                      ? "2"
                      : "1"
                  );
                }
              }}
              sx={{
                "&.Mui-checked": {
                  color: "#13A800",
                },
              }}
            />
          }
          label={
            <Box component="li" className={classes.customerBox}>
              {option.director_firstname +
                " " +
                option.director_lastname +
                " | " +
                option.country_name +
                " " +
                option.country_code +
                " " +
                option.city +
                " | " +
                option.postal_code +
                " | " +
                option.customer_address +
                " | " +
                option.email +
                " | " +
                option.telephone}
            </Box>
          }
        />
      </div>
    );
  };
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <>
      {openSearch ? (
        <div className={classes.customerSelect}>
          <img
            className={classes.closeIcon}
            src={close_icon}
            alt="close"
            onClick={() => {
              clearCustomer();
              setForm(initialState);
              setOpenSearch(false);
            }}
          />
          <Grid container rowSpacing={0.5} columnSpacing={2}>
            <Grid item xs={12} md={4} lg={2}>
              <div className={classes.label}>Name</div>
              <TextField
                size="small"
                fullWidth
                name="director_firstname"
                value={form.director_firstname || ""}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={2}>
              <div className={classes.label}>Surname</div>
              <TextField
                size="small"
                fullWidth
                name="director_lastname"
                value={form.director_lastname || ""}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={2}>
              <div className={classes.label}>Post Index</div>
              <TextField
                size="small"
                fullWidth
                name="postal_code"
                value={form.postal_code || ""}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={2}>
              <div className={classes.label}>Phone</div>
              <PhoneField
                {...{
                  value: form.telephone,
                  setForm,
                  isRequired: false,
                  hideLabel: true,
                }}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={2}>
              <div className={classes.label}>ID</div>
              <TextField
                size="small"
                fullWidth
                name="contract_id"
                value={form.contract_id || ""}
                onChange={handleChange}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
              lg={2}
              style={{
                display: "flex",
                alignItems: "end",
                justifyContent: "center",
              }}
            >
              <Button
                variant="contained"
                className={classes.btn}
                onClick={handleSubmit}
              >
                Find
              </Button>
            </Grid>
            <Grid item xs={12}>
              {isLoading ? (
                <Loading />
              ) : customers.length ? (
                <RadioGroup
                  value={customerId}
                  className={classes.customerRadioGroup}
                >
                  <div style={{ width: "100%", height: 400 }}>
                    <AutoSizer>
                      {({ width, height }) => (
                        <List
                          width={width}
                          height={height}
                          rowCount={customers.length}
                          rowHeight={isMobile ? 110 : 80}
                          rowRenderer={rowRenderer}
                          overscanRowCount={5}
                        />
                      )}
                    </AutoSizer>
                  </div>
                </RadioGroup>
              ) : (
                <div className={classes.noData}>No data</div>
              )}
            </Grid>
          </Grid>
        </div>
      ) : (
        <div className={classes.customerSelectLayer}>
          <div className={classes.title}>
            <img src={icon} alt="icon" className={classes.icon} />
            <span>{label}</span>
          </div>
          {!disableFind && (
            <Button
              variant="outlined"
              className={classes.findBtn}
              onClick={() => setOpenSearch(true)}
            >
              Find in list
            </Button>
          )}
        </div>
      )}
    </>
  );
}
